import React from "react";

const Button = ({
  size = "md",
  variant = "primary",
  rounded = "md",
  className = "",
  children,
  onClick,
  type = "button",
  disabled,
}) => {
  const sizeClasses = {
    sm: "py-2 px-4 text-sm",
    md: "py-2 px-5 text-base",
    lg: "py-3 px-6 text-lg",
  };

  const roundingClass = rounded === "full" ? "rounded-full" : "rounded-[6px]";

  const variantClasses =
    variant === "outline"
      ? "border border-[#1E3A5F] text-[#1E3A5F] bg-white hover:bg-[#F4F7FB]"
      : "bg-[#14B48C] hover:bg-[#11997A] text-white";

  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 font-semibold transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed ${roundingClass} ${variantClasses} ${sizeClasses[size]} ${className}`}
    >
      {children}
    </button>
  );
};
export default Button;
